module.exports = __webpack_public_path__ + "img/wxicon.99dc1355.png";